/* eslint-disable no-lone-blocks */
/* eslint-disable default-case */
import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { PARTICIPANTS_SELECTION_MODULES } from 'constants/ProjectConstants';
import { endpoints } from 'constants/endpoints';

const ENABLED_FILTERS = {
  LOCATION: 'LOCATION',
  COMPANY_ID: 'COMPANY_ID',
};

const REACT_QUERY_KEYS = {
  GET_ALL_FILTERS: 'GET_ALL_FILTERS',
};

const getFiltersApi = (module) =>
  sendRequest({
    url: endpoints.reviewCreationV2.filteredReviewee,
    credentials: 'include',
    method: 'POST',
    body: [ENABLED_FILTERS.LOCATION, ENABLED_FILTERS.COMPANY_ID],
    queryParams: {
      module,
    },
  });

export const useGetAllFilters = (module, enabled = true) =>
  useQuery({
    queryKey: [REACT_QUERY_KEYS.GET_ALL_FILTERS],
    queryFn: () => getFiltersApi(module).then((res) => res.entity.filters),
    enabled,
  });

export const uploadParticipantsCSVApi = ({ fileObject, queryParams, module }) => {
  let url = '';
  switch (module) {
    case PARTICIPANTS_SELECTION_MODULES.ENGAGEMENT: {
      url = endpoints.engagementV2.surveyCreation.uploadParticipantsCSV;
      break;
    }

    case PARTICIPANTS_SELECTION_MODULES.REVIEW: {
      url = endpoints.reviewCreationV2.uploadParticipantsFile;
      break;
    }

    default:
      break;
  }
  const data = new FormData();
  data.append('file', fileObject);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: data,
    isMultiPart: true,
    queryParams,
  });
};

export const saveParticipantsApi = ({ payload, module }) => {
  let url = '';
  switch (module) {
    case PARTICIPANTS_SELECTION_MODULES.ENGAGEMENT: {
      url = endpoints.engagementV2.surveyCreation.saveSurveyParticipants;
      break;
    }

    case PARTICIPANTS_SELECTION_MODULES.REVIEW: {
      url = endpoints.reviewCreationV2.saveReviewCycleParticipants;
      break;
    }

    case PARTICIPANTS_SELECTION_MODULES.COMPENSATION: {
      // url = endpoints.compensationV2.saveCompensationParticipants;  // enable after BE Change
      url = endpoints.reviewCreationV2.saveReviewCycleParticipants;

      break;
    }

    default:
      break;
  }
  return sendRequest({
    url,
    credentials: 'include',
    method: 'PUT',
    body: payload,
  }).then((res) => res.entity);
};

export const downloadSelectedParticipantsCSVApi = async ({ queryParams, module }) => {
  let url = '';
  switch (module) {
    case PARTICIPANTS_SELECTION_MODULES.ENGAGEMENT: {
      url = endpoints.engagementV2.surveyCreation.downloadSelectedParticipantsCSV;
      break;
    }

    case PARTICIPANTS_SELECTION_MODULES.REVIEW: {
      url = endpoints.reviewCreationV2.downloadSelectedParticipantsCSV;
      break;
    }

    default:
      break;
  }
  try {
    const res = await sendRequest({
      url,
      method: 'GET',
      credentials: 'include',
      queryParams,
    });

    // Get the file content (base64) and file name from the response
    const { fileContent, fileType, fileName } = res?.entity || {};

    if (!fileContent) {
      throw new Error('No file content or file name found in the response');
    }

    // Decode base64 to binary data
    const binaryData = atob(fileContent);

    // Create a Uint8Array to hold the binary data
    const uint8Array = new Uint8Array(binaryData.length);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([uint8Array], { type: fileType });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  } catch (err) {
    console.log(err.message);
  }
};
